import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('plan_shared_business_rule', '/plan_shared_business_rules', 'business_rules')
const reducer = generator.generate()

export default reducer
